import {
  Component,
  Injector,
  Input,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppComponentBase } from '@shared/common/app-component-base';
import { MessageService } from 'abp-ng2-module';
import {
  Field,
  FormDefinitionDto,
  FormsServiceProxy,
  DataSetsServiceProxy,
  IFormApprovalInput,
  FormApprovalInput,
  FormStatus,
} from '@shared/service-proxies/service-proxies';
import { Router } from '@angular/router';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomDateAdapter } from '@shared/helpers/CustomDateAdapter';
import { CloneActivityModalComponent } from '../activities-assign-panel/clone-activity-modal/clone-activity.modal.component';
import * as moment from 'moment';

@Component({
  selector: 'app-activities-dynamic-form-panel',
  templateUrl: './activities-dynamic-form-panel.component.html',
  styleUrls: ['./activities-dynamic-form-panel.component.scss'],
  providers: [
    { provide: FormsServiceProxy },
    { provide: DataSetsServiceProxy },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: DateAdapter, useClass: CustomDateAdapter }
  ],
})
export class ActivitiesDynamicFormPanelComponent extends AppComponentBase {
  constructor(
    injector: Injector,
    private _router: Router,
    private _formServiceProxy: FormsServiceProxy,
    private _dataSetsServiceProxy: DataSetsServiceProxy,
    private _messageService: MessageService,
  ) {
    super(injector);
  }
  payLoad = '';
  form = new FormGroup({});

  @ViewChild('cloneActivityModal', { static: true })
  cloneModal: CloneActivityModalComponent;

  private _formDef: FormDefinitionDto;
  @Input()
  set formDef(val) {
    this._formDef = val;
    this.form = this.toFormGroup(this._formDef?.fields);
    this.formDef?.fields?.forEach((element) => {
      if (element.isActive && this._formData) {
        this.form?.controls[element.id].setValue(
          this._formData[
            Object.keys(this._formData).find(
              (key) => key.toLowerCase() === element.id.toLowerCase()
            )
          ]
        );
        }
    });
  }
  get formDef() {
    return this._formDef;
  }

  private _formData;
  @Input()
  set formData(val) {
    this._formData = val;
    this.formDef?.fields?.forEach((element) => {
      if (element.isActive) {
        this.form?.controls[element.id].setValue(
          this._formData[
            Object.keys(this._formData).find(
              (key) => key.toLowerCase() === element.id.toLowerCase()
            )
          ]
        );}
    });
  }
  get formData() {
    return this._formData;
  }

  toFormGroup(controls: Field[]) {
    const group: any = {};
    controls?.forEach((control) => {
      if (control.isActive) {
        if(control.validations instanceof Array && control.validations.some(v=>v.validationType == "required")) {
          group[control.id] = new FormControl('', Validators.required);
        } else {
            group[control.id] = new FormControl();
        }
      }
      if(control.dataSetEnabled == true) {
        this._dataSetsServiceProxy
        .getDataSetFieldData(control.dataSet.fieldName, control.dataSet.storeName)
        .subscribe((x: any) => {
            var dataset = x.map(function(item: any){
                return {
                    display: item
                };
            });
            control.options = dataset;

            if (
              control &&
              control.controlType === 'radio' &&
              control.dataSetEnabled &&
              this.form.get(control.id).value
            ) {
              const fieldId = this.form.get(control.id)?.value?.display?.['fieldId'];
              const option = control.options.find(
                (option) => option.display?.['fieldId'] === fieldId
              );
              if (option) {
                this.form.get(control.id)?.setValue(option);
              }
            }

            if (
              control &&
              control.controlType === 'checkbox' &&
              this.form.get(control.id).value
            ) {
              if (control.dataSetEnabled) {
                this.form.get(control.id)?.value?.forEach((element) => {
                  control.options.find((x) => x.display['fieldId'] === element.fieldId).value = 'true';
                });
              } else {
                this.form.get(control.id)?.value?.forEach((element) => {
                  control.options.find((x) => x.id === element).value = 'true';
                });
              }
            }

        });
      }
    });
    return new FormGroup(group);
  }

  closing() {
    this._router.navigateByUrl(
        '/app/main/resourcesAllocation/activities'
    );
  }
  deleteDay(): void {
    this.message.confirm('', this.l('RemoveADConfirmation'), (isConfirmed) => {
      if (isConfirmed) {
        this._formServiceProxy.deleteFormData(this.formData['definitionId'],this.formData['id'])
          .subscribe(() => {
            this.closing();
            this.notify.success(this.l('FormHasBeenRemoved'))
          });
      }
    });
  }

  async onSubmit(isAutoSave = '') {
    if(this.formData['submittable'] && !isAutoSave) {
        this.submitAllocationSheet();
        this._router.navigate(
            [
                '/app/main/resourcesAllocation/allocation-dynamic-forms',
                this.formData['id'],
            ],
            { queryParams: { definitionId: this.formData['definitionId'], id: this.formData['id'] } }
        );
    } else {
        if (!this.form.valid && !isAutoSave) {
            this.notify.error(this.l('InvalidFormMessage'));
            return;
        }
        if(!this.formData['activityName']) {
            this.notify.error(this.l('RequiredField', 'Activity Description'));
            return;
        }
        if(!this.formData['activityDate']) {
            this.notify.error(this.l('RequiredField', 'Activity Day'));
            return;
        }
        let rowData = this.form.getRawValue();
        this.payLoad = rowData;
        let formData = {
        'definitionId': this.formData['definitionId'],
        'shortNumber' : this.formData['shortNumber'],
        'id' : this.formData['id'],
        'activityName' : this.formData['activityName'],
        'activityDate' : new Date(this.formData['activityDate'])
        }
        let jsonData ={
        'rowData': rowData,
        'formData': formData
        }
        this._formServiceProxy
        .patchFormData(
            jsonData
        )
        .subscribe((x) => {
            // this.notify.success(this.l('ActivityHasBeenCreated'));
            this._formData = x;
            this.formDef?.fields?.forEach((element) => {
            if (element.isActive && this._formData) {
                if (element.dataSetEnabled == true && this.form.get(element.id).value) {
                var a = this.form.get(element.id).value
                this._formData[element.id] = element.dataSet;

                if (element.controlType === 'radio') {
                    if(this.form.get(element.id).value.display?.['fieldId']){
                    const fieldId = this.form.get(element.id)?.value?.display?.['fieldId'];
                    const option = element.options.find((option) => option.display?.['fieldId'] === fieldId);
                    option['fieldDefinition'] = element.dataSet;
                    if (option) {
                        this.form?.controls[element.id].setValue(option);
                    }
                    }
                } else {
                    this.form?.controls[element.id].setValue(
                    this._formData[
                        Object.keys(this._formData).find(
                        (key) => key.toLowerCase() === element.id.toLowerCase()
                        )
                    ]
                    );
                }
                }
            }
            });
            if(!isAutoSave) {
                this.submitAllocationSheet();
                this._router.navigate(
                    [
                        '/app/main/resourcesAllocation/allocation-dynamic-forms',
                        this.formData['id'],
                    ],
                    { queryParams: { definitionId: this.formData['definitionId'], id: this.formData['id'] } }
                );
            }
        });
    }
  }

  submitAllocationSheet() {
    const body: IFormApprovalInput = {
      definitionId: this.formDef.id,
      formDataId: this._formData.id,
      stepId: -1,
      approval: FormStatus.Submitted,
      comment: undefined,
    };
    this._formServiceProxy
      .approveFormData(new FormApprovalInput(body))
      .subscribe((x) => {
        this._messageService.success(this.l('FormSuccessSubmit'));
      });
  }

  cloneForm(copyWithData: boolean) {
    if (!this.formData['id']) return;
    let selectedDays: string [] = [];

    this._formServiceProxy.getFormByName(this.formData["definitionId"], this.formData["activityName"]).subscribe(form => {
    form.items.forEach(item => {
    let activityDate = moment(item['activityDate']);
    let formattedDate = activityDate.format('YYYY-MM-DD');
    selectedDays.push(formattedDate) });

    this.cloneModal.disabledDays = selectedDays
    this.cloneModal.copyWithData = copyWithData;
    this.cloneModal.isDynamicForm = true;
    this.cloneModal.formBody = this.formData;
    this.cloneModal.modal.show()
  });
  }

  afterClone() {
    this.notify.success(this.l('ActivityHasBeenCloned'));
  }

}
